import ProspectorProApiService from './ProspectorProApiService';

export default class AgentService extends ProspectorProApiService {
  // getByOaId(identifier) {
  //   return new Promise((resolve, reject) => {
  //     this.get('/AgentREST/get-by-oaagentid', {}, identifier)
  //       .then((agentData) => {
  //         resolve(agentData);
  //       }, (err) => {
  //         // Handle the rejection caused by no agent find by id
  //         // that should not throw an error
  //         if (err.indexOf('No agent found with oaagentid ') > -1) {
  //           resolve({});
  //         } else {
  //           reject(err);
  //         }
  //       });
  //   });
  // }
}
